import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledStrip = styled.div`
  background: ${CSSVars.white};
  padding: 24px 20px 40px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 32px 30px 56px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 40px 40px 64px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;

  .label {
    font-family: ${CSSVars.primaryFont};
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
    letter-spacing: 0.3px;
  }

  .pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }

  .pill {
    display: inline-flex;
    align-items: center;
    background: ${CSSVars.white};
    border: 1px solid ${CSSVars.gray200};
    border-radius: 999px;
    padding: 8px 16px;
    font-family: ${CSSVars.primaryFont};
    font-weight: 500;
    font-size: 13px;
    color: #4b5563;
    text-decoration: none;
    transition: all 0.2s ease;

    &:hover {
      border-color: ${CSSVars.blue500};
      color: ${CSSVars.blue500};
      background: rgba(76, 79, 255, 0.05);
      transform: translateY(-1px);
    }

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 14px;
      padding: 10px 18px;
    }
  }

  /* Non-link chip, used when a widget has no published platform spokes. */
  .pill.static {
    cursor: default;

    &:hover {
      border-color: ${CSSVars.gray200};
      color: #4b5563;
      background: ${CSSVars.white};
      transform: none;
    }
  }
`;
